import type { ApiRoute, NoBody, NoPathParams, NoQueryParams } from "../api"
import type { DealerContextView } from "../context/DealerContextView"

export const getDealerContextRoute: ApiRoute<NoPathParams, NoQueryParams, NoBody, DealerContextView> = {
	buildUrl: () => "/context",
	method: "get",
	path: "/context",
}
